import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { CoreService } from '../../../../services/core.service';
import { SubmitGridComponent } from '../../components/submit-grid/submit-grid.component';
import { SectionGridComponent } from '../../components/section-grid/section-grid.component';
import { StepperGridComponent } from '../../components/stepper-grid/stepper-grid.component';
import { FooterGridComponent } from '../../components/footer-grid/footer-grid.component';

@Component({
  selector: 'app-create-plaform',
  imports: [ReactiveFormsModule, CommonModule, SectionGridComponent, SubmitGridComponent, StepperGridComponent, FooterGridComponent],
  templateUrl: './create-plaform.component.html',
  styleUrl: './create-plaform.component.scss'
})
export class CreatePlaformComponent {
  @Input() embeddedMode = false;
  @Input() companyIdInput: string | null = null;
  platformForm: FormGroup;
  companyId: string | null = null;
  contentSiteId: string | null = null;
  siteOptions: any[] = [];
  hasDefaultSite = false;
  showPromptField = false;
  showFbPrompts = false;
  showIgPrompts = false;
  showTikTokPrompts = false;
  @Input() hasBorder: boolean = true;

  @Output() onSubmitClbk = new EventEmitter<any>();

  constructor(
    private fb: FormBuilder,
    private coreService: CoreService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.platformForm = this.fb.group({
      platform: ['', Validators.required],
      ms_contentsite_id: [''],
      social_media_id: ['', Validators.required],
      access_token: ['', [Validators.required, Validators.minLength(190)]],
      app_id: ['', [Validators.required, Validators.minLength(1)]],
      app_secret: ['', [Validators.required, Validators.minLength(1)]],
      fbDefaultPrompt: [''],
      fbAlternativePrompt: [''],
      igDefaultPrompt: [''],
      igAlternativePrompt: [''],
      tikTokDefaultPrompt: [''],
      tikTokAlternativePrompt: ['']
    });
  }

  ngOnInit() {
    // Get company ID from route parameter
    this.route.params.subscribe(params => {
      this.companyId = this.companyIdInput || params['company'];
      this.contentSiteId = params['site'];
      console.log('Company ID from route:', this.companyId);
      console.log('Site ID from route:', this.contentSiteId);

      if (this.companyId) {
        // Load sites for this company
        this.loadSites();
      }
    });

    // Watch for platform changes to show/hide prompts
    this.platformForm.get('platform')?.valueChanges.subscribe(value => {
      this.updatePromptVisibility(value);
    });

    // Check if editing existing platform
    // if (this.formData?.ID) {
    //   this.loadPlatformData(this.formData.ID);
    // }
  }

  private loadSites(): void {
    this.coreService.getData(`/manageAccount/content-site?companyID=${this.companyId}`).subscribe({
      next: (data) => {
        this.siteOptions = data || [];

        // Check if there's a default site
        this.hasDefaultSite = this.siteOptions.some(site =>
          site.Domain === 'default' || site.siteUrl === 'default'
        );

        // If default site exists and no site selected, auto-select it
        if (this.hasDefaultSite && !this.platformForm.get('ms_contentsite_id')?.value) {
          const defaultSite = this.siteOptions.find(site =>
            site.Domain === 'default' || site.siteUrl === 'default'
          );
          if (defaultSite) {
            this.platformForm.patchValue({
              ms_contentsite_id: defaultSite.ID
            });
          }
        }
        else {
          if (this.contentSiteId) {

            const contentSiteExists = this.siteOptions.some(contentSite =>
              contentSite.ID == this.contentSiteId || contentSite.id == this.contentSiteId
            );

            if (contentSiteExists) {
              // Set the form value
              this.platformForm.patchValue({
                ms_contentsite_id: this.contentSiteId
              });

              // Keep it disabled
              this.platformForm.get('ms_contentsite_id')?.disable();
            } else {
              console.warn(`Company with ID ${this.companyId} not found in companies list`);
              // Optionally enable the field if company not found
              // this.userForm.get('companyID')?.enable();
            }
          }
        }
      },
      error: (error) => {
        console.error('Error loading sites:', error);
      }
    });
  }

  private updatePromptVisibility(platform: string): void {
    // Reset all prompts visibility
    this.showFbPrompts = false;
    this.showIgPrompts = false;
    this.showTikTokPrompts = false;
    this.showPromptField = false;

    // Show prompts based on selected platform
    switch (platform) {
      case 'Facebook':
        this.showFbPrompts = true;
        this.showPromptField = true;
        break;
      case 'Instagram':
        this.showIgPrompts = true;
        this.showPromptField = true;
        break;
      case 'TikTok':
        this.showTikTokPrompts = true;
        this.showPromptField = true;
        break;
      default:
        this.showPromptField = false;
    }
  }

  private loadPlatformData(platformId: string): void {
    this.coreService.getData(`manageAccount/platform/${platformId}`).subscribe({
      next: (data) => {
        this.platformForm.patchValue(data);
        this.updatePromptVisibility(data.platform);
      },
      error: (error) => {
        console.error('Error loading platform data:', error);
      }
    });
  }

  // Helper method to get form controls
  getControl(controlName: string) {
    return this.platformForm.get(controlName);
  }

  onSubmit(): void {
    if (this.platformForm.valid) {
      // Get form values
      const formData = this.platformForm.getRawValue();

      // Add companyID from route params
      const dataToSubmit = {
        ...formData,
        companyID: this.companyId,
      };

      // Determine if this is create or update
      // const endpoint = this.formData?.ID
      //   ? `manageAccount/platform/update/${this.formData.ID}`
      //   : 'manageAccount/platform/store';

      this.coreService.postData('manageAccount/platform/store', dataToSubmit).subscribe({
        next: (data) => {
          if (this.embeddedMode) {
            this.onSubmitClbk.emit(data);
          } else {
            console.log('Platform operation successful:', data);

            const companyId = data.companyID || data.data?.companyID;
            const siteId = data.ms_contentsite_id || data.data?.ms_contentsite_id;

            if (companyId) {
              this.router.navigate(['/manage-account/create-feed', companyId, siteId]);
            } else {
              console.error('No company ID found in response:', data);
            }

            // Optional: Reset form
            // this.resetForm();
          }
        },
        error: (error) => {
          console.error('Error creating/updating platform:', error);

          // Handle specific errors
          if (error.status === 400) {
            alert('Invalid platform data. Please check your inputs.');
          } else if (error.status === 409) {
            alert('Platform connection already exists for this site.');
          }
        }
      });
    } else {
      this.markFormGroupTouched(this.platformForm);
    }
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

  resetForm(): void {
    this.platformForm.reset({
      platform: '',
      ms_contentsite_id: this.hasDefaultSite ?
        this.siteOptions.find(s => s.Domain === 'default' || s.siteUrl === 'default')?.ID || '' : '',
      social_media_id: '',
      access_token: '',
      app_id: '',
      app_secret: '',
      fbDefaultPrompt: '',
      fbAlternativePrompt: '',
      igDefaultPrompt: '',
      igAlternativePrompt: '',
      tikTokDefaultPrompt: '',
      tikTokAlternativePrompt: ''
    });

    this.platformForm.markAsPristine();
    this.platformForm.markAsUntouched();

    // Reset prompt visibility
    this.updatePromptVisibility('');
  }

}
